var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-main branding-bg",attrs:{"data-trackname":"footer"}},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("© "+_vm._s(_vm.year)+" BMAT")])])])}
var staticRenderFns = []

export { render, staticRenderFns }